import { action } from 'mobx';

import { AppManager, Input } from 'core/index';

import { StoryMutation } from 'apps/story/gql';
import { StoryApp } from 'apps/story/app';
import { SpaceApp } from 'apps/space/app';
import { TagsApp } from 'apps/tag/app';

export class NewStoryAppManager extends AppManager {
  static registryName = 'NewStoryAppManager';
  constructor(parent, init = {}) {
    super(parent, init);
    this.storyApp = new StoryApp(this, {
      inSpace: new SpaceApp(),
      tags: new TagsApp(),
    });
    this.storyApp.createForms();
  }

  @action Publish = story => {
    const input = new Input({
      title: () => story.title,
      body: () => story.body,
      spaceId: () => story.inSpace.id,
      tags: () =>
        story.tags.map(({ id, name, deleted }) => ({ id, name, deleted })),
      avatar: () => (story.avatar ? story.avatar.id : undefined),
    });
    const options = {
      onSysErr: story.onPublishErr,
      onUserErr: story.onPublishErr,
      onSuccess: story.onPublishSuccess,
    };
    const mutation = new StoryMutation(input);
    mutation.setCallbacks(options);
    mutation.mutate();
    return mutation;
  };
}
